import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { BillToParty } from '../../../enums/bill-to-party';
import { ShippingAccountColumnContainer } from '../../../containers/shipping-account-column-container';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const ShippingAccountColumn = ({ fulfillmentId }) => {
  const { labelFulfillment, fulfillmentPlanId } =
    useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const labelConfiguration =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId,
        property: 'labelConfiguration',
      }),
    ) ?? {};

  const { options } = labelConfiguration ?? {};
  const { billToAccount } = options ?? {};
  const { accountNumber, billToParty } = billToAccount ?? {};
  const { sellerLabelProviderId } = labelFulfillment;

  if (!sellerLabelProviderId) {
    return null;
  }

  return (
    <ShippingAccountColumnContainer
      billToAccount={accountNumber}
      billToParty={BillToParty.find((party) => party === billToParty)}
      shippingProviderId={sellerLabelProviderId}
    />
  );
};

ShippingAccountColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const ShippingAccount = {
  getMessageDescriptor: () => messages.shippingAccount,
  id: 'shippingAccount',

  render: (data) => {
    return <ShippingAccountColumn fulfillmentId={data.id} />;
  },
};
